import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AccountingPeriodService {
  URl = this.ConfigService.getAPIBaseUrl() + 'api/AccountingPeriodBasicInfo'
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  getBasicInfoData(APPeriodId) {
    return this.http.get(this.URl +'/GetBasicInfo?ApperiodId='+APPeriodId)
  }
  getBasicInfoDataLY(APPeriodId) {
    return this.http.get(this.URl + '/GetBasicInfoLY?ApperiodId=' + APPeriodId)
  }
  InsertBasicInfo(data) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.URl + '/InsertBasicInfo', data, httpOptions)
  }


  //for showbubble
  private _apShowBubble: string = null;
  private readonly apShowBubbleKey: string = 'ShowBubble'

  public setShowBubble(showBubble: any) {
    localStorage.setItem(this.apShowBubbleKey, showBubble);
    this._apShowBubble = showBubble;
  }

  public get getShowBubble(): any {
    return this._apShowBubble;
  }

}
